/// <amd-module name="TFS/Admin/Groups/Common/Services/OrganizationGroupsBreadcrumbService" />
import { IReadonlyObservableArray, ObservableArray } from "VSS/Core/Observable";
import { Services, VssService } from "VSS/Platform/Context";

import { IBreadcrumbItemService } from "VSS/Features/PlatformUI/ContributedBreadcrumb";
import { IBreadcrumbItem } from "VSSUI/Breadcrumb.Types";
import { FastPageSwitch } from "VSS/Platform/FPS";

export class OrgGroupsBreadcrumbService extends VssService implements IBreadcrumbItemService {
    private items = new ObservableArray<IBreadcrumbItem>();

    public getBreadcrumbItems(): IReadonlyObservableArray<IBreadcrumbItem> {
        return this.items;
    }

    public setSelectedEntityBreadcrumb(name: string, url?: string) {
        this.items.push({
            key: "SelectedGroup",
            text: name,
            rank: 100, // Selected Pivot is at rank: 50, so this puts us far enough above to avoid accidental mis sorting.
            onClick: url
                ? () => {
                      FastPageSwitch(this.pageContext, url, true);
                  }
                : undefined
        });
    }
}

export const OrgGroupsBreadcrumbServiceName = "org-groups-breadcrumb-service";

Services.add(OrgGroupsBreadcrumbServiceName, { serviceFactory: OrgGroupsBreadcrumbService });
